<template>
  <div>
    <!-- Page Content -->
    <div class="content">
      <!-- Full Table -->
      <base-block rounded title="Notify Me List">
        <div class="text-right">
          <b-button variant="success" href="/#/backend/forms/add-notify-me"
            >+ Add Notify Me</b-button
          >
        </div>
        <br />
        <div class="d-flex justify-content-end mb-2">
          <input
            class="form-control"
            type="text"
            placeholder="Search..."
            aria-label="Search"
            style="width: 300px"
          />
        </div>
        <b-table-simple responsive bordered striped table-class="table-vcenter">
          <b-thead>
            <b-tr>
              <b-th class="text-center">S.NO</b-th>
              <b-th class="text-center">Test</b-th>
              <b-th class="text-center">User</b-th>
              <b-th class="text-center">Notification Date</b-th>
              <b-th class="text-center">Action</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="banner in banners" :key="banner.id">
              <b-td class="text-center">
                {{ banner.sno }}
              </b-td>
              <b-td class="text-center">
                {{ banner.test }}
              </b-td>
              <b-td class="text-center">
                {{ banner.user }}
              </b-td>
              <b-td class="text-center">
                {{ banner.notificationDate }}
              </b-td>
              <b-td class="text-center">
                <b-btn-group>
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    href="/#/backend/forms/add-notify-me"
                  >
                    <i class="fa fa-fw fa-pencil-alt"></i>
                  </b-button>
                  <b-button size="sm" variant="alt-primary" href="">
                    <i class="fa fa-fw fa-times"></i>
                  </b-button>
                </b-btn-group>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </base-block>
      <!-- END Full Table -->
    </div>
    <!-- END Page Content -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [
        {
          id: 1,
          test: "Numbers Test 1",
          sno: "1",
          notificationDate: "20-02-2021",
          user: "Rasheed Ahamed",
        },
        {
          id: 2,
          test: "Numbers Test 2",
          sno: "2",
          notificationDate: "23-02-2021",
          user: "Praveen",
        },
        {
          id: 3,
          test: "Quantitative 3",
          sno: "3",
          notificationDate: "25-02-2021",
          user: "Elavarasan",
        },
        {
          id: 4,
          test: "Verbal Easy",
          sno: "4",
          notificationDate: "28-02-2021",
          user: "Partha",
        },
      ],
    };
  },
};
</script>
